import type { FunctionComponent } from 'react';
import { useCurrentJob } from 'hooks';
import { AlertBanner } from '@kanda-libs/ks-design-library-new';

const ExampleJobAlertBanner: FunctionComponent = function () {
  const { isExampleJob } = useCurrentJob();

  if (!isExampleJob) return <></>;

  return (
    <div className="mb-4">
      <AlertBanner>
        This is an example job. You can safely apply for credit without
        providing correct details or having a credit check run against you. This
        is to give you an idea of how the checkout will function for your end
        customer.
      </AlertBanner>
    </div>
  );
};

export default ExampleJobAlertBanner;
